/* np-dialog — shared modal behaviour for snippets/np-dialog.liquid.

   Everything is delegated from document, so:
     - any number of sections can use dialogs with no per-section init
     - dialogs added later (theme editor re-render) work with no re-binding
     - the script is safe to include from several sections; the guard below
       means it only ever attaches one set of listeners

   Native <dialog> supplies the top layer, focus trapping and Esc. */
(function () {
  'use strict';
  if (window.__npDialogLoaded) return;
  window.__npDialogLoaded = true;

  /* ---------------------------------------------------------------------
     Warm a dialog's images before it is opened.

     A <dialog> is display:none until shown, so an img[loading=lazy] inside it
     never becomes "near viewport" and the browser never starts the fetch. The
     download therefore begins from scratch on click — measured at 2,290 ms
     from tap to visible image on mobile / Slow 4G, versus feeling instant on
     desktop where the connection hides it.

     Flipping loading to "eager" starts the fetch immediately (display:none
     does not suppress eager loading), and the browser picks the correct
     srcset candidate. Triggered from the TRIGGER's visibility rather than the
     dialog's, because the trigger is on screen while the dialog is not — so
     only dialogs the user can actually reach get warmed, not all 16 at once.
  --------------------------------------------------------------------- */
  function warmDialog(dlg) {
    if (!dlg || dlg.__npWarmed) return;
    dlg.__npWarmed = true;
    var imgs = dlg.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
  }

  function warmFromTrigger(el) {
    if (!el) return;
    warmDialog(document.getElementById(el.getAttribute('data-np-dialog-open')));
  }

  function observeTriggers(scope) {
    var triggers = (scope || document).querySelectorAll('[data-np-dialog-open]');
    if (!triggers.length) return;

    /* Immediate intent — pointerdown/touchstart fire before click. */
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('pointerenter', function () { warmFromTrigger(this); }, { once: true, passive: true });
      triggers[i].addEventListener('touchstart', function () { warmFromTrigger(this); }, { once: true, passive: true });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        warmFromTrigger(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '200px' });
    for (var j = 0; j < triggers.length; j++) io.observe(triggers[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeTriggers(); });
  } else {
    observeTriggers();
  }
  document.addEventListener('shopify:section:load', function (e) { observeTriggers(e.target); });

  function openDialog(id) {
    var dlg = document.getElementById(id);
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  }

  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-np-dialog-open]');
    if (opener) {
      e.preventDefault();
      warmFromTrigger(opener);
      openDialog(opener.getAttribute('data-np-dialog-open'));
      return;
    }

    var closer = target.closest('[data-np-dialog-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }

    /* Backdrop: a click landing on the <dialog> itself rather than on
       .np-dialog__inner is outside the panel. */
    if (target.tagName === 'DIALOG' && target.classList.contains('np-dialog')) {
      closeDialog(target);
    }
  });
})();
